import React, { lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
const TipsLanding = lazy(() => import("Components/TipsTutorials/TipsLanding"));
const TipsInner = lazy(() => import("Components/TipsTutorials/TipsInner"));

const TipsAndTutorialsRoutes = () => {
  return (
    // <Router basename="">
    <Switch>
      <Route path="/tipsandtutorials/:id" component={TipsInner} />
      <Route path="/tipsandtutorials/" component={TipsLanding} />
    </Switch>
  );
};

export default TipsAndTutorialsRoutes;
